import {Box, Button, Card, Divider} from '@material-ui/core';
import React, {useCallback, useEffect, useState} from 'react';
import {apiGetCreditNoteByInvoice} from 'constants/Api';
import {IFarmInputCreditNote} from 'constants/interfaces';
import {NavigationService} from 'services/index';
import {Skeleton} from '@material-ui/lab';

export function CreditNoteCard(props: {invoiceId: number}) {
  const [isLoading, setIsLoading] = useState(false);
  const [creditNote, setCreditNote] = useState<IFarmInputCreditNote>();

  const loadCreditNote = useCallback((invoiceId: number) => {
    setIsLoading(true);
    apiGetCreditNoteByInvoice(invoiceId)
      .then((creditNote) => setCreditNote(creditNote || undefined))
      .catch((error) => {
        alert('Error loading credit note. Please try again later');
        console.error(error);
      })
      .finally(() => setIsLoading(false));
  }, []);

  useEffect(() => {
    loadCreditNote(props.invoiceId);
  }, [props.invoiceId, loadCreditNote]);

  const handleCreateCreditNote = () => {
    NavigationService.navigate(
      '/create-credit-note/?invoice=' + props.invoiceId,
    );
  };

  const handleDownload = () => {
    if (!creditNote || !creditNote.documentUrl) return;
    const url = createCacheAvoidingUrl(creditNote.documentUrl);
    const newWindow = window.open(url, '_blank');
    if (newWindow) newWindow.opener = null;
  };

  function createCacheAvoidingUrl(url: string) {
    const searchParamToAvoidCache = `date=${new Date().getTime()}`;
    const appendChar = url.includes('?') ? '&' : '?';
    return `${url}${appendChar}${searchParamToAvoidCache}`;
  }

  if (isLoading)
    return <Skeleton variant="rect" height={100} style={{borderRadius: 8}} />;

  return (
    <Card className="supporting-documents-card" variant="outlined">
      {!!creditNote?.documentUrl && (
        <>
          <Box padding={1} display={'flex'} justifyContent={'center'}>
            <Button
              variant={'text'}
              size={'small'}
              color={'primary'}
              onClick={handleDownload}
            >
              Download Credit Note
            </Button>
          </Box>
          <Divider />
        </>
      )}
      <Box padding={1} display={'flex'} justifyContent={'center'}>
        <Button
          variant={'text'}
          size={'small'}
          color={'primary'}
          onClick={handleCreateCreditNote}
        >
          {!creditNote ? 'Create' : 'Update'} Credit Note
        </Button>
      </Box>
    </Card>
  );
}
